import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NotificationHelpers"*/ './lazyIndex'),
    { name: 'NotificationHelpers' }
);

export const lazyLaunchRemindersPopup: LazyAction<
    typeof lazyIndex.launchRemindersPopup,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.launchRemindersPopup);
export const lazyCloseRemindersPopup: LazyAction<
    typeof lazyIndex.closeRemindersPopup,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.closeRemindersPopup);
export const lazyGetNotificationCustomSoundURL: LazyAction<
    typeof lazyIndex.getNotificationCustomSoundURL,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getNotificationCustomSoundURL);
export { RemindersPopupActionSource } from './reminderHelpers/remindersPopupActionSource';
